import Grid from '@mui/material/Grid';

import styles from '../Form.module.scss';

interface PersonalDetailsHeaderProps {
  restrictGuTeamsForPa: boolean;
}

const PersonalDetailsHeader = ({ restrictGuTeamsForPa }: PersonalDetailsHeaderProps) => {
  if (restrictGuTeamsForPa) {
    return (
      <Grid
        container
        spacing={2}
        className={styles.personalDetailsHeader}
        sx={{
          alignItems: 'center',
        }}
      >
        <Grid
          size={{
            sm: 6,
          }}
        >
          <p className={styles.formTitle}>Personal Details</p>
        </Grid>
        <Grid
          size={{
            sm: 6,
          }}
        >
          <Grid container spacing={2}>
            <Grid
              size={{
                sm: 6,
              }}
            />
            <Grid
              size={{
                sm: 6,
              }}
            >
              <p className={styles.formNoteInline}>
                Note: you may only assign a Global User to teams to which you have access{' '}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return (
    <div className={styles.personalDetailsTitleOnly}>
      <p className={styles.formTitle}>Personal Details</p>
    </div>
  );
};

export default PersonalDetailsHeader;
